document.addEventListener('DOMContentLoaded', () => {
  const defaultButton = document.querySelector('.gift-finder-default-btn');
  const defaultContent = document.querySelector('.gift-finder-default-content');
  const questionGrid = document.querySelector('.gift-finder-question-grid');

  if (defaultButton && questionGrid) {
    defaultButton.addEventListener('click', () => {
      questionGrid.classList.remove('hidden');
      defaultContent.classList.add('hidden');
    });
  }
});

document.addEventListener('click', function (e) {
  const nextBtn = e.target.closest('.gift-finder-question-next-btn');
  if (!nextBtn) return;

  const currentQuestion = nextBtn.closest('.gift-finder-question-inner');
  if (!currentQuestion) return;

  const checkedRadio = currentQuestion.querySelector('input[type="radio"]:checked');
  if (!checkedRadio) return;

  const handle = checkedRadio.getAttribute('data-handleize');
  const parentWrapper = currentQuestion.closest('.gift-finder-question-grid');

  let nextElement = null;

  // Only check direct children of parentWrapper
  if (handle) {
    nextElement = parentWrapper.querySelector(`.child-of-${handle}`);
  }

  // If no child-of-[handle] exists, find next sibling gift-finder-question-inner that is NOT child-of-*
  if (!nextElement) {
    let sibling = currentQuestion.nextElementSibling;
    while (sibling) {
      if (
        sibling.classList.contains('gift-finder-question-inner') &&
        !Array.from(sibling.classList).some(cls => cls.startsWith('child-of-'))
      ) {
        nextElement = sibling;
        break;
      }
      sibling = sibling.nextElementSibling;
    }
  }

  if (!nextElement) {
    currentQuestion.classList.add('complete');
    showGiftFinderResult(parentWrapper);
    return;
  };

  // Hide current and show next
  currentQuestion.classList.add('hidden', 'complete');
  // Hide all child-of-* elements (safety)
  Array.from(parentWrapper.children).forEach(el => {
    if (Array.from(el.classList).some(cls => cls.startsWith('child-of-'))) {
      el.classList.add('hidden');
    }
  });

  const banner_image = nextElement.getAttribute('data-banner-image');
  const banner_title = nextElement.getAttribute('data-banner-title');

  const bannerImageElem = parentWrapper.querySelector('.gift-finder-question-grid-banner-image');
  if (bannerImageElem && banner_image) {
    bannerImageElem.src = banner_image;
  }

  const bannerTitleElem = parentWrapper.querySelector('.gift-finder-question-grid-banner-title');
  if (bannerTitleElem && banner_title) {
    bannerTitleElem.textContent = banner_title;
  }

  nextElement.classList.remove('hidden');

  // --- Step counter & progress bar ---
  let currentStep = parseInt(document.getElementById('current-step-num')?.textContent) || 1;
  const totalSteps = parseInt(document.getElementById('total-step-num')?.textContent) || 1;

  currentStep = Math.min(currentStep + 1, totalSteps);
  document.getElementById('current-step-num').textContent = currentStep;

  const progressPercent = (currentStep / totalSteps) * 100;
  const progressBar = parentWrapper.querySelector('.gift-finder-progress-bar');
  if (progressBar) progressBar.style.width = `${progressPercent}%`;
});


function showGiftFinderResult(wrapper) {
  const completedQuestions = wrapper.querySelectorAll('.gift-finder-question-inner.complete');
  var giftFinderSelectedOption = '';

  completedQuestions.forEach(question => {
    const checked = question.querySelector('input[type="radio"]:checked');
    if (checked) {
      const value = checked.value;
      if(value != '') {
        giftFinderSelectedOption = value + ',' + giftFinderSelectedOption;
        giftFinderSelectedOption = giftFinderSelectedOption.replace(/,\s*$/, '');
      }
    }
  });

  if(giftFinderSelectedOption != '') {
    var finalCollection = '/collections/all';
    var finalCollectionElement = document.getElementById('final-collection');
    if(finalCollectionElement) {
      var finalCollection = document.getElementById('final-collection').textContent.trim();
    }
    const collectionRedirectUrl = finalCollection + '?filter.p.tag=' + giftFinderSelectedOption.split(',').join('&filter.p.tag=') + '&sort_by=best-selling';
    window.location.href = collectionRedirectUrl;
  } else {
    alert('Please select requried option');
  }

}